import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'objectToString',
})
export class ObjectToStringPipe implements PipeTransform {
  transform(value: any, showJson: boolean = false): string {
    if (!value) return '';
    if (typeof value === 'object') {
      // Opción 1: Mostrar campos específicos si es posible
      if (value.hasOwnProperty('nombre')) {
        return value.nombre; // Cambia 'nombre' por el campo deseado
      }
      // Opción 2: Convertir a JSON si no hay campos específicos
      return showJson ? JSON.stringify(value, null, 2) : '[Object]';
    }
    return value.toString();
  }
}
